"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALCHEMY_SECRET_TEST = exports.ALCHEMY_SECRET_PROD = exports.ALCHEMY_API_KEY_TEST = exports.ALCHEMY_API_KEY_PROD = exports.SIMPLEX_API_KEY_TEST_QUOTE = exports.SIMPLEX_API_KEY_TEST = exports.SIMPLEX_API_KEY_PROD = exports.BANXA_CODE = exports.MERCURYO_WIDGET_SELL_ID = exports.MERCURYO_WIDGET_BUY_ID_SANDBOX = exports.MERCURYO_WIDGET_BUY_ID = exports.MOONPAY_API_KEY_DEV = exports.MOONPAY_API_KEY_PROD = exports.TRANSAK_API_KEY_STAGE = exports.TRANSAK_API_KEY_PROD = exports.RAMP_API_KEY = void 0;
// RAMP
exports.RAMP_API_KEY = "6gnxz2tsz7yabpcfxupqyqzzkvov2h9n6h8ba68f";
// TRNASAK
exports.TRANSAK_API_KEY_PROD = "90605579-f9e3-4137-9145-ebf9617a35d7";
exports.TRANSAK_API_KEY_STAGE = "aaa2c924-3cfa-4caf-92f5-b5ccca8d29f0";
// MOONPAY
exports.MOONPAY_API_KEY_PROD = "pk_live_k6WSd0AaHVEXPV4WlBBrsvRMrAhRH";
exports.MOONPAY_API_KEY_DEV = "pk_test_1BktOhJqGEW5LuoslX9z1Kupc76LfWrz";
// MERCURYO
exports.MERCURYO_WIDGET_BUY_ID = "85b39026-8a0d-4a0c-964f-e2993cf01738";
exports.MERCURYO_WIDGET_BUY_ID_SANDBOX = "6ca1e560-76cf-4da9-9257-ab77b5280d9b";
exports.MERCURYO_WIDGET_SELL_ID = "8dd4b9ce-5b08-4718-b9a0-bd2e6c33c001";
// BANXA
exports.BANXA_CODE = "d87817022a88012465f4";
// SIMPLEX
exports.SIMPLEX_API_KEY_PROD = "pk_live_d8dba7e8-c58e-4f3b-8318-6a0f6ad923af";
exports.SIMPLEX_API_KEY_TEST = "pk_test_cdac5746-fb48-4489-bf18-10fb9028ac90";
exports.SIMPLEX_API_KEY_TEST_QUOTE = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwYXJ0bmVyIjoiYml0Y29pbmNvbWFwaSIsImlwIjpbIjEuMi4zLjQiXSwic2FuZGJveCI6dHJ1ZX0.BpvkpRPlKeXwLTSmgBOX3cSCQHgXcqIfAlnCG0Q7JQI";
// ALCHEMY
exports.ALCHEMY_API_KEY_PROD = "30hECKlxCdX1GyX4";
exports.ALCHEMY_API_KEY_TEST = "f83Is2y7L425rxl8";
exports.ALCHEMY_SECRET_PROD = "xP7MPuL0r1xKpkeV";
exports.ALCHEMY_SECRET_TEST = "4Yn8RkxDXN71Q3p0";
//# sourceMappingURL=apiKeys.js.map